import React, { useEffect, useContext, useState } from 'react';
import Accordion from '../../../../../../../components/Accordion/Accordion';
import { makeStyles } from '@material-ui/core/styles';
import ReportItem from '../ReportItem';
import { store as mainStore } from '../../../../../../../store';
import axios from '../../../../../../../api/axios';
import Circular from '@material-ui/core/CircularProgress';
import useTitle from 'hooks/useTitle';
import { useQuery } from 'react-query';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    top: '0',
    right: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Daily = () => {
  useTitle('گزارش های روزانه');
  const classes = useStyles();
  const { showMessage, showError } = useContext(mainStore);
  const [statistics, setStatistics] = useState({});
  const [progress, setProgress] = useState(false);
  const {
    pending,
    tendering,
    returned,
    rejected,
    getWaybill,
    movingTowardsOrigin,
    transporting,
    delivered,
    canceled,
  } = statistics;

  const getTodayReport = async () => {
    try {
      setProgress(true);
      const { data } = await axios.get(
        `/api/v1/admin/reports/todayAllStatuses`
      );
      if (data?.ok) {
        setStatistics(data?.today);
      }
    } catch (error) {
      showError(error);
    }
    setProgress(false);
  };

  const { data } = useQuery('loadTodayReport', getTodayReport, {
    cacheTime: 60 * 60 * 1000,
  });

  return (
    <Accordion title="عملکرد روزانه" open>
      <div className={classes.root}>
        {progress && (
          <div className={classes.loading}>
            <Circular style={{ color: '#fff' }} />
          </div>
        )}
        <ReportItem
          color="#ffa726"
          title="درحال بررسی"
          count={pending || '0'}
          link={`/protected/admin/orders?status=pending`}
        />
        <ReportItem
          color="#ffeb3b"
          contrast={false}
          title="مناقصه"
          count={tendering || '0'}
          link={`/protected/admin/orders?status=tendering`}
        />
        <ReportItem
          color="#2196f3"
          title="صدور بارنامه"
          count={getWaybill || '0'}
          link={`/protected/admin/orders?status=getWaybill`}
        />
        <ReportItem
          color="#558b2f"
          title="بارگیری"
          count={movingTowardsOrigin || '0'}
          link={`/protected/admin/reports/ready`}
        />
        <ReportItem
          color="#9e9d24"
          title="درحال حمل"
          count={transporting || '0'}
          link={`/protected/admin/orders?status=transporting`}
        />
        <ReportItem
          color="#6a1b9a"
          title="تحویل شده"
          count={delivered || '0'}
          link={`/protected/admin/orders?status=delivered`}
        />
        <ReportItem
          color="#b0bec5"
          title="برگشت بار"
          count={returned || '0'}
          link={`/protected/admin/reports/returns`}
        />
        <ReportItem
          color="#795548"
          title="رد بار"
          count={rejected || '0'}
          link={`/protected/admin/reports/rejects`}
        />
        <ReportItem
          color="#b71c1c"
          title="کنسل بار"
          count={canceled || '0'}
          link={`/protected/admin/reports/cancels`}
        />
        <ReportItem
          color="#283593"
          title="گزارش پورسانت‌ها"
          link={`/protected/admin/reports/commissions/daily`}
          colspan={3}
        />
      </div>
    </Accordion>
  );
};

export default Daily;
